import type { WebhookDeliveryStatus } from '@entities/webhook'

const REDELIVERABLE_STATUSES = new Set<WebhookDeliveryStatus>([
  'DELIVERED',
  'DEAD',
  'RETRYING',
  'SUPPRESSED',
])

export function canRedeliverDelivery(status: WebhookDeliveryStatus): boolean {
  return REDELIVERABLE_STATUSES.has(status)
}

export function redeliveryConfirmation(status: WebhookDeliveryStatus): string {
  return status === 'DELIVERED'
    ? 'Esta entrega já foi concluída. Reenviar pode repetir a ação no sistema de destino. Deseja continuar?'
    : 'O endpoint receberá novamente o mesmo evento e identificador. Deseja continuar?'
}
